const reviews = document.querySelector(".js-review-slider");

if(reviews) {
    const slides = reviews.querySelectorAll('.review-slider__wrapper');
    if(slides.length > 1) {
        var enableDots = true;
        var enableWrap = true;
    } else {
        var enableDots = false;
        var enableWrap = false;
    }
    var flkty = new Flickity( reviews, {
      // options
      cellAlign: 'left',
      contain: true,
      wrapAround: enableWrap,
      prevNextButtons: false,
      pageDots: enableDots,
      adaptiveHeight: true
    });
}